{
  "button": "Share",
  "heading": "Share this schedule",
  "byline": "Invite people to edit or view this schedule",
  "hint": "Separate multiple email addresses with a comma.",
  "invite_button": "Invite",
  "email_placeholder": "Email addresses",
  "generic_email_error": "Error adding this email address",
  "all_emails_are_collaborators_error": "All entered emails are already collaborators",
  "max_collaborators_reached": "The maximum number of collaborators has been reached",
  "remove_access": "Remove access",
  "transfer_owner": "Transfer ownership",
  "leave_schedule": "Leave schedule",
  "you": "(you)",
  "confirm_remove": {
    "title": "Remove {{user}} from {{schedule}}?",
    "confirm": "Remove"
  },
  "confirm_transfer": {
    "title": "Make {{user}} the owner?",
    "message": "The new owner will be notified and could remove you from this schedule. You also might lose the ability to change share settings.",
    "confirm": "Yes, transfer ownership"
  },
  "transfer_success_toast": "Ownership transferred",
  "transfer_error_toast": "Error transferring ownership",
  "invite_success_toast_one": "{{email}} invited!",
  "invite_success_toast_other": "{{count}} users invited!",
  "owner": "Owner",
  "editor": "Editor",
  "viewer": "Viewer",
  "public_link_access": {
    "public": "Anyone with the link can view",
    "private": "Only invited users can access"
  },
  "invalid_email": "{{email}} is not a valid email"
}
